'use client'

import type { ComponentProps } from 'react'
import { Printer } from 'lucide-react'
import { Button } from './Button'
import { Icon } from './Icon'

/**
 * Le geste qui produit le PDF.
 *
 * `window.print()` ouvre la boîte d'impression du navigateur, dont « Enregistrer
 * au format PDF » est une destination : c'est ainsi que ce projet fabrique un
 * PDF, faute de bibliothèque de génération — voir `src/styles/impression.css`,
 * qui porte la décision et la mise en page.
 *
 * Le bouton se retire lui-même de la page imprimée (`print:hidden`) : il ne fait
 * pas partie du document.
 *
 * ⚠️ **Remonté ici le 2026-09-14, depuis deux jumeaux identiques** —
 * `espace/certificat/BoutonImprimer.tsx` et `admin/contrats/BoutonImprimer.tsx`
 * — qui le demandaient tous deux en commentaire : « à remonter dans
 * `components/ui` au prochain passage sur ce baril ». Le troisième écran à
 * produire un document, la feuille d'émargement, est ce passage : trois copies
 * d'un `window.print()` auraient commencé à diverger.
 */
export function BoutonImprimer({
  children,
  variant = 'ghost',
}: {
  children: string
  /** `action` dans l'Oasis 2027, où imprimer est l'action principale. */
  variant?: ComponentProps<typeof Button>['variant']
}) {
  return (
    <Button
      variant={variant}
      icon={<Icon as={Printer} size={16} />}
      onClick={() => window.print()}
      className="print:hidden"
    >
      {children}
    </Button>
  )
}
